import SolutionsShow from "../components/solutions/Show";

export default [
  { name: 'Solutions', path: '/solutions', component: SolutionsShow,  }
]
